import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, createVNode as _createVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import BaseIcon from '@/shared/legacy/ui/base-icon/icon.vue';
import { useI18N } from '@/shared/legacy/lib/use-i18n';

type Props = {
  confirmOnRemove?: boolean;
  hasError?: boolean;
};


export default /*@__PURE__*/_defineComponent({
  __name: 'base-attachment-remove-button',
  props: {
    confirmOnRemove: { type: Boolean, default: false },
    hasError: { type: Boolean, default: false }
  },
  emits: ["action"],
  setup(__props: any, { emit: __emit }) {



const emit = __emit;

const i18n = useI18N();

const handleClick = (event: MouseEvent) => {
  if (__props.confirmOnRemove && !confirm(i18n('confirm'))) {
    return;
  }
  emit('action', event);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("span", {
    role: "button",
    class: _normalizeClass(_ctx.$style.removeButton),
    "data-qa": "remove-button",
    onClick: _withModifiers(handleClick, ["stop"])
  }, [
    _createVNode(BaseIcon, {
      class: _normalizeClass([_ctx.$style.removeIcon, { [_ctx.$style.error]: __props.hasError }]),
      type: "x-close"
    }, null, 8, ["class"])
  ], 2))
}
}

})